import Link from 'next/link';
import { useRouter } from 'next/router';
import Head from 'next/head'
import React from 'react';
import * as brandsAjax from '../../ajax/brands';
import chunkArray from '../../utils/chunkArray';
import styles from './BrandPage.module.css';
import type { Brand } from '../../types/Brand';

// This function gets called at build time on server-side.
// It won't be called on client-side
export async function getStaticProps(context) {
  const brands = await (await brandsAjax.getBrands()).json();

  return {
    props: {
      brands,
    },
    revalidate: 86400, // 24hr
  }
}

interface Props {
  brands: Brand[];
}

const metaDescription = 'Find spare or replacement parts for treadmills, ellipticals, and more, including Proform, NordicTrack, Schwinn, Weider, Weslo, Bowflex, Nautilus, HealthRider, Image, Precor, and more.';

export default function Brands(props: Props) {
  const router = useRouter();

  function handleBrandClick(brand: Brand) {
    router.push('/brand/' + brand.name_slug);
  }

  return (
    <div className={styles.root}>
      <Head>
        <title>Brands | Fitness and Exercise Equipment Repair Parts</title>
        <meta
          name="description"
          content={metaDescription}
        />
        <meta
          name="keywords"
          content="exercise, equipment, repair, replacement, spare, parts, fitness, excercise, Proform, NordicTrack, Schwinn, Weider, Weslo, Bowflex, Nautilus, Healthrider, Image, Precor, Horizon, Tunturi, Parabody, Trimline, SportCraft"
        />
        <link
          rel={"canonical" as const}
          href="https://www.fitnessrepairparts.com/brand"
        />
        <meta property="og:title" content="Brands | FitnessRepairParts.com" />
        <meta property="og:url" content="https://www.fitnessrepairparts.com/brand" />
        <meta property="og:type" content="page" />
        <meta property="og:image" content="https://www.fitnessrepairparts.com/images/logo_acronym_blue.jpg" />
        <meta property="og:description" content={metaDescription} />
        <meta httpEquiv="content-language" content="en-us" />
      </Head>
      <h2 className={styles.title}>Brand Names</h2>
      <div id="brand_icons" className={styles.brandsContainer}>
        {chunkArray(props.brands, Math.max(props.brands.length / 7, 1)).map((chunk, i) => (
            chunk.map((brand) => (
              <div
                key={brand.id}
                className={styles.brandCell}
                onClick={() => handleBrandClick(brand)}
              >
                <div className={styles.brandContent}>
                  {brand.images?.small ?
                    <Img
                      src={brand.images?.small}
                      alt={brand.name}
                    />
                    : null}
                  <br />
                  <Link href={'/brand/' + brand.name_slug}>{brand.name}</Link>
                </div>
              </div>
            ))
        ))}
        <p style={{ margin: 0 }}>All trademarks and registered trademarks are the property of their respective owners.</p>
      </div>
    </div>
  );
}

interface ImgProps {
  src: string;
  alt: string;
}

function Img(props: ImgProps) {
  const [error, setError] = React.useState(false);

  if (error) {
    return null;
  }

  return (
    <img
      src={props.src}
      alt={props.alt}
      onError={() => {
        console.log('error', props.alt)
        setError(true)
      }}
    />
  );
}